// extracted by mini-css-extract-plugin
export var resizer = "_hz-0";